import { useMutation } from "@tanstack/react-query";
import { createBrandLanguage } from "../api/createBrandLanguage";
import { CreateBrandLanguage } from "../type";

type Params = {
  brandId: string;
  language: CreateBrandLanguage;
};

export const useCreateBrandLanguageMutation = (languageCode: string) => {
  return useMutation({
    mutationKey: ["createBrandLanguage", languageCode],
    mutationFn: async ({ brandId, language }: Params) => {
      return await createBrandLanguage(brandId, language);
    },
  });
};
